import React from 'react';
import { PropertyCard } from '../components/PropertyCard';
export function Collections() {
  const properties = [{
    id: 'the-ark',
    title: 'The Ark',
    type: 'Spacious 4-BHK Villa • 2 Floors',
    bedrooms: 4,
    bathrooms: 4,
    sleeps: 14,
    beds: 3,
    price: '₹12,499',
    image: 'https://a0.muscache.com/im/pictures/hosting/Hosting-1318026329502115922/original/520ca652-f1a5-4e24-a765-74ae5cc897f8.png?im_w=1440',
    airbnbUrl: 'https://airbnb.co.in/h/fortkochin',
    featured: true
  }, {
    id: 'the-haven',
    title: 'The Haven',
    type: 'Stylish 3BHK Apartment',
    bedrooms: 3,
    bathrooms: 3,
    sleeps: 12,
    beds: 3,
    price: '₹8,499',
    image: 'https://a0.muscache.com/im/pictures/hosting/Hosting-1392648310736278217/original/50bf55c8-d9cc-4562-bc5f-0efaf4402535.jpeg?im_w=1440',
    airbnbUrl: 'https://www.airbnb.co.in/h/keralam',
    featured: true
  }, {
    id: 'ark-green',
    title: 'Ark Green',
    type: 'Stylish 2BHK Suite',
    bedrooms: 2,
    bathrooms: 2,
    sleeps: 5,
    beds: 3,
    price: '₹7,499',
    image: 'https://a0.muscache.com/im/pictures/hosting/Hosting-1300574331154492461/original/f39bc531-627c-420a-b66d-74c2bb383fd3.jpeg?im_w=1440',
    airbnbUrl: 'https://www.airbnb.co.in/rooms/1312900432950527324',
    featured: true
  }, {
    id: 'ark-gold',
    title: 'Ark Gold',
    type: 'Stylish 2BHK Suite',
    bedrooms: 2,
    bathrooms: 3,
    sleeps: 6,
    beds: 3,
    price: '₹6,499',
    image: 'https://a0.muscache.com/im/pictures/hosting/Hosting-1312900432950527324/original/7241b004-b870-4614-987e-63f0ae367f2d.jpeg?im_w=1440',
    airbnbUrl: 'https://www.airbnb.co.in/rooms/1300574331154492461',
    featured: true
  }];
  return <div className="min-h-screen bg-[#FAF7F2] pt-12 pb-24" data-id="element-217">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-218">
        {/* Header with Superhost Badge */}
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-219">
          <div className="inline-flex items-center gap-2 bg-white px-4 py-2 rounded-full shadow-sm mb-4" data-id="element-220">
            <span className="text-2xl" data-id="element-221">🏆</span>
            <span className="text-sm font-bold text-[#2C2C2C]" data-id="element-222">
              All Properties are Airbnb Superhosts
            </span>
          </div>
          <h1 className="font-serif text-4xl md:text-5xl font-bold text-[#2C2C2C] mb-6" data-id="element-223">
            Our Collection
          </h1>
          <p className="text-[#5C5C5C] text-lg leading-relaxed" data-id="element-224">
            Four distinct properties in Maradu, Kochi. Each one rated 4.96+
            stars and recognized as a Guest Favourite on Airbnb.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" data-id="element-225">
          {properties.map(property => <div key={property.id} className="h-full" data-id="element-226">
              <PropertyCard {...property} data-id="element-227" />
            </div>)}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center bg-white rounded-2xl p-12 shadow-lg" data-id="element-228">
          <h3 className="font-serif text-2xl font-bold text-[#2C2C2C] mb-4" data-id="element-229">
            Ready to Book Your Stay?
          </h3>
          <p className="text-[#5C5C5C] mb-6 max-w-xl mx-auto" data-id="element-230">
            All our properties are available on Airbnb with instant booking.
            Choose your dates and reserve your perfect Kochi home today.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-231">
            <a href="https://airbnb.co.in/h/fortkochin" target="_blank" rel="noopener noreferrer" className="inline-block" data-id="element-232">
              <button className="px-8 py-4 bg-[#FF385C] text-white rounded-lg font-medium hover:bg-[#E31C5F] transition-colors flex items-center justify-center gap-2" data-id="element-233">
                <svg className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor" data-id="element-234">
                  <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0zm0 22C6.5 22 2 17.5 2 12S6.5 2 12 2s10 4.5 10 10-4.5 10-10 10z" data-id="element-235" />
                  <path d="M12 6c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6zm0 10c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4z" data-id="element-236" />
                </svg>
                Book on Airbnb
              </button>
            </a>
            <a href="https://wa.me/919746603446" target="_blank" rel="noopener noreferrer" className="inline-block" data-id="element-237">
              <button className="px-8 py-4 bg-[#25D366] text-white rounded-lg font-medium hover:bg-[#128C7E] transition-colors" data-id="element-238">
                Chat on WhatsApp
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>;
}